Pegasus.FormInputTypesObject = Em.Object.extend({
  types: function(){
    var emailTranslation = Em.I18n.t('g.email').capitalize();
    var textTranslation = Em.I18n.t('g.text').capitalize();

    var types = {
      email: {
        willPrepend: '',
        test: new RegExp(  ),
        display: emailTranslation
      },
      text: {
        willPrepend: '',
        test: new RegExp(  ),
        display: textTranslation
      }
    };

    return types;
  }.property(),

  content: function(){
    var types = this.get('types');
    var content = Object.keys(types).map(function (key) {
      return types[key].display;
    });
    if ( content.length ) {
      return content;
    }
    return [];
  }.property('types.@each.display'),

  selected: '',

  updateSelected: function(){
    if ( !this.get('controller.type') ) { return; }
    this.set('selected', this.get('types')[ this.get('controller.type') ].display );
  }.observes('controller.type'),

  selectedType: function(){
    var types = this.get('types'),
      selected = this.get('selected');

    for( var i in types ){
      if( types.hasOwnProperty( i ) ){
        if( types[i].display === selected ){
          this.set( 'controller.type', i );
          break;
        }
      }
    }
  }.observes('selected')
});

Pegasus.InputTypesMixin = Ember.Mixin.create({
  didInsertElement: function(){
    this.set('inputTypes', Pegasus.FormInputTypesObject.create({
      controller: this
    }));
    this.get('inputTypes').updateSelected();
    this.get('inputTypes.types');
    this._super();
  },

  inputTypes: null
});
